module.exports = __webpack_public_path__ + "media/images/journey-night01-dfb7e143686070b3ec35404ed95ab401.jpg";